// UI Constants for modals
export const MODAL_UI = {
  DIMENSIONS: {
    WIDTH: '480px',
    BORDER_RADIUS: '8px',
  },
  INPUTS: {
    HEIGHT: '52px',
    BORDER_COLOR: {
      DEFAULT: '#e2e8f0',
      FOCUSED: '#6d28d9',
      ACCENT: '#4a96d9',
    },
    FONT_SIZE: {
      NORMAL: '16px',
      LARGE: '18px',
    },
    PADDING: {
      NORMAL: '12px 16px',
      CURRENCY: '0 54px 0 16px',
    },
  },
  BUTTONS: {
    HEIGHT: '2.25rem',
    BORDER_RADIUS: '8px',
    COLORS: {
      PRIMARY: {
        BG: '#4a96d9',
        HOVER: '#4a96d9',
        DARKER: '#4a96d9',
      },
      OUTLINE: {
        BG_HOVER: '#f8fafc',
        BORDER: '#e2e8f0',
      },
      DANGER: {
        BG: '#ef4444',
        HOVER: '#dc2626',
      },
    },
    FONT_WEIGHT: 500,
  },
  PAYMENT_METHOD: {
    ICON_SIZE: '12',
  },
  SPACING: {
    XS: '8px',
    SM: '16px',
    MD: '24px',
    LG: '32px',
  },
  OVERLAY: {
    OPACITY: 0.75,
    BLUR: 3,
  },
};

// Message constants for modals
export const MODAL_MESSAGES = {
  AVOIR_SUBTITLE: 'Créer un nouvel avoir',
  DECAISSER_SUBTITLE: '',
  MAXIMUM_AMOUNT: 'Montant maximum',
  AVOIR_CASHIER_SELECTION_TITLE:
    "Sélectionner la caisse où enregistrer l'avoir :",
};

export const modalsTitles = {
  avoirTitle: 'Avoir',
  decaisserTitle: 'Décaissement',
};
